import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import appLogo from "../../assets/images/header-footer/app-logo.png";
import langIcon from "../../assets/images/header-footer/language.png";
import useWindowSize from "../../hooks/useWindowSize";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import i18n from "../../localization/LocalesConfig";
import { get, handleLogout } from "../../services/apiService";
import MenuIcon from "@mui/icons-material/Menu";
import BackdropLoader from "../common/BackdropLoader";

const Header = ({ isDashboard, onSetMode, onSetDrawerOpen, isDrawerOpen }) => {
  const langLabel =
    sessionStorage.getItem("preferredLanguage") === "ar" ? "العربية" : "English";
  const userId = sessionStorage.getItem("userId");
  const [activeLanguage, setActiveLanguage] = useState(langLabel);
  const [anchorEl, setAnchorEl] = useState(null);
  const [langEl, setLangEl] = useState(null);
  const { updateCurrentLang } = useAuth();
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const theme = useTheme();
  const [userInfo, setUserInfo] = useState({});
  const [websiteUrl, setWebsiteUrl] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const onLoading = () => {};


  useEffect(() => {
    const fetchUserStep = async () => {
      try {
        if (userId) {
          const response = await get(`users/${userId}`, {}, onLoading);
          if (response.status === 200) {
            const userInfo = response.data;
            // setWebsiteUrl(response.data.websiteUrl);
            setUserInfo(userInfo);
          }
        }
      } catch (error) {

        // Fallback to sessionStorage if API call fails
      }
    };

    fetchUserStep();
  }, [userId]);

  if (!t) {
    console.error("Translation function is not available!");
    return null;
  }

  const languages = [
    {
      label: "English",
      lang: "en",
    },
    {
      label: "العربية",
      lang: "ar",
    },
  ];

  const isLoggedIn = sessionStorage.getItem("authToken");

  const handleMenuOpen = (event) => {
    if (event.currentTarget) {
      setAnchorEl(event.currentTarget); // Set anchor to the icon button
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Close the menu by setting anchor to null
  };

  const handleLangMenuOpen = (event) => {
    if (event.currentTarget) {
      setLangEl(event.currentTarget); // Set anchor to the icon button
    }
  };

  const handleChangeLanguage = (lang) => {
    setLangEl(null); // Always close the menu
    // if (lang === "en" || lang === "ar") {
    sessionStorage.setItem("preferredLanguage", lang);
    sessionStorage.setItem("direction", lang === "en" ? "ltr" : "rtl");
    i18n?.changeLanguage(lang);
    setActiveLanguage(lang === "en" ? "English" : "العربية");
    updateCurrentLang(lang); // Always update context
    // }
  };

  const onScreenLoading  = (isLoading) => {
    setIsLoading(isLoading);
  }

  const handlePublishWebsite = async() => {
    const publishWebsiteResponse = await get(`users/${userId}/publish/website`, {}, onScreenLoading);
    setWebsiteUrl(publishWebsiteResponse?.data?.websiteurl);
  }



  const handleVisitWebsite = () => {
    window.open(websiteUrl, '_blank');
  }



  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "white",
        boxShadow: 0,
        padding: "1%",
        width: "100%", // Make sure the AppBar takes up the full width
        overflowX: "hidden", // Prevent horizontal scroll
      }}
    >
    {isLoading && <BackdropLoader/>}
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%", // Ensure Toolbar takes full width
          overflowX: "hidden", // Prevent horizontal scroll in Toolbar
        }}
      >
        {/* Left: Logo */}
        {!isDashboard ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#000" }}>
              <Link to="/">
                <img src={appLogo} alt="logo" width={100} height={51.68} />
              </Link>
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex" }}>
            <Button
               sx={{
                marginLeft: width < 600 ? "3%" : "10px",
                color: "white",
                width:width> 900 ? '200px' :'125px',
                backgroundColor: '#312c75',
                fontFamily: "Tajawal-Regular",
                fontSize:width> 900 ?'18px' :'12px'
              }}
              onClick={onSetMode}
            >
              {t("Preview Website")}
            </Button>
            <Button
              sx={{
                marginLeft: width < 600 ? "3%" : "10px",
                color: "white",
                width:width> 900 ? '200px' :'125px',
                backgroundColor: '#312c75',
                fontFamily: "Tajawal-Regular",
                fontSize:width> 900 ?'18px' :'12px'
              }}

              onClick={handlePublishWebsite}
              
            >
              {t("Publish Website")}
            </Button>

             {websiteUrl?.length > 0 && 
            <Button
              sx={{
                marginLeft: width < 600 ? "3%" : "10px",
                color: "white",
                width:width> 900 ? '200px' :'125px',
                backgroundColor: '#312c75',
                fontFamily: "Tajawal-Regular",
                fontSize:width> 900 ?'18px' :'12px'
              }}

              onClick={handleVisitWebsite}
              
            >
              {t("Visit Website")}
            </Button>
             }
          </Box>
        )}

        {/* Center: Navigation Items */}

        {/* Right: Profile, Language, and Hamburger Icon */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: width > 600 ? "15px" : "1px",
          }}
        >
          {isLoggedIn ? (
            <>
              {width > 500 && (
                <Typography
                  sx={{
                    color: "#004D8A",
                    fontWeight: "700",
                    marginLeft: "30px",
                    fontFamily: "Tajawal-Regular",
                     fontSize:width> 900 ?'18px' :'12px'
                  }}
                >
                  {t("Welcome")} {userInfo ? userInfo.fullName : "Guest"}
                </Typography>
              )}

              <IconButton onClick={handleMenuOpen}>
                <AccountCircle
                  sx={{ fontSize: width > 600 ? 50 : 36, color: "#004D8A" }}
                />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)} // Open menu if anchorEl is set
                onClose={handleMenuClose} // Close menu on outside click
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Set dropdown position
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: {
                    width: activeLanguage === "العربية" ? "140px" : "100px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center", // Set your desired width here
                  },
                }}
              >
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    handleLogout();
                  }}
                  style={{
                    color: "#004D8A",
                    fontFamily: "Tajawal-Bold",
                    cursor: "pointer",
                    marginTop: "-10%",
                     fontSize:width> 900 ?'18px' :'12px'
                  }}
                >
                  {t("Logout")}
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Link to="/signin">
                <Button
                  sx={{
                    marginLeft: width < 600 ? "20%" : "0px",
                    color: "white",
                    width:
                      langLabel === "en"
                        ? width > 600
                          ? "113px"
                          : "30%"
                        : width > 600
                          ? "153px"
                          : "30%",
                    backgroundColor: theme.palette.button.primary,
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {t("Signin")}
                </Button>
              </Link>
              <Link to="/signup">
                <Button
                  variant="outlined"
                  sx={{
                    marginLeft: width < 600 ? "20%" : "0px",
                    border: "1px solid #3173B1",
                    width: width > 600 ? "126px" : "35%",
                    color: "#3173B1",
                    backgroundColor: theme.palette.button.light,
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {t("Signup")}
                </Button>
              </Link>
            </>
          )}

          {/* Language Icon */}
       
            <>
          <IconButton sx={{ color: "#000" }} onClick={handleLangMenuOpen}>
            <img
              src={langIcon}
              alt="language"
              width={width > 600 ? 50 : 30}
              height={width > 600 ? 50 : 30}
            />
          </IconButton>
          <Menu
            anchorEl={langEl}
            open={Boolean(langEl)} // Open menu if anchorEl is set
            onClose={() => setLangEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Set dropdown position
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                width: "100px",
                display: "flex",
                justifyContent: "center",
                textAlign: "center", // Set your desired width here
              },
            }}
          >
            {languages && languages?.length > 0 ? (
              languages?.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleChangeLanguage(item.lang)}
                  style={{
                    color: "#004D8A",
                    fontFamily: "Tajawal-Bold",
                    cursor: "pointer",
                  }}
                >
                  {item.label}
                </MenuItem>
              ))
            ) : (
              <MenuItem style={{ textAlign: "center" }}>No Languages</MenuItem>
            )}
          </Menu>
          </>
          
          {width > 450 && (
            <Typography sx={{ color: "#004D8A", marginTop: "3%" }}>
              {activeLanguage}
            </Typography>
          )}
          {width < 900 && (
            <IconButton
              sx={{ color: "#004D8A", marginTop: "3%"  }}
              onClick={()=>onSetDrawerOpen(!isDrawerOpen)}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
